import { userPrivileges } from 'api/User/selectors'
import { connect } from 'react-redux'
import { changeDataSorting, fetchStoreDetails } from 'revenue/actions'

import RevenueDetailsTable from './RevenueDetailsTable'
import { getStoreList } from './selectors'

const mapStateToProps = (state, ownProps) => ({
  countriesSortingInformation: state.ui.countryStores.countriesSortingInformation,
  isCumulative: state.datePicker.typeAnalysis !== 'perDay',
  isFetching: ownProps.type === 'stores' ? state.stores.isFetchingAllStores : state.ui.countryStores.isFetching,
  stores: getStoreList(state, ownProps),
  userPrivileges: userPrivileges(state),
})

const mapDispatchToProps = {
  changeDataSorting,
  fetchStoreDetails,
}

export default connect(mapStateToProps, mapDispatchToProps)(RevenueDetailsTable)
